{
  "version": 1,
  "asset_id": "9f5a53c0-2424-4f24-83a7-ace87157ac8f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/9f5a53c0-2424-4f24-83a7-ace87157ac8f/lap-band-diagram-900.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/9f5a53c0-2424-4f24-83a7-ace87157ac8f/lap-band-diagram-900.webp",
  "original_filename": "lap-band-diagram-900.webp",
  "size": 26688,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:13:02Z"
}
